import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { MenuComponent } from './menu/menu.component';
import { VerifyphonenumberComponent } from './verifyphonenumber/verifyphonenumber.component';
import { FormErrorComponent } from './form-error/form-error.component';
import { SafeDatePipe } from '../pipes/safe-date.pipe';

// import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    MenuComponent,
    VerifyphonenumberComponent,
    FormErrorComponent,
    SafeDatePipe,
  ],
  exports: [
    MenuComponent,
    VerifyphonenumberComponent,
    FormErrorComponent,
    SafeDatePipe,
  ],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    // FormsModule,
    // ReactiveFormsModule,
  ]
})
export class ComponentsModule { }
